/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as StrankeRouteImport } from './routes/stranke'
import { Route as PonudbeRouteImport } from './routes/ponudbe'
import { Route as KoledarRouteImport } from './routes/koledar'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NastavitveIndexRouteImport } from './routes/nastavitve/index'
import { Route as KliciIndexRouteImport } from './routes/klici/index'
import { Route as PravnoSlugRouteImport } from './routes/pravno/$slug'
import { Route as OnboardingVoiceRouteImport } from './routes/onboarding/voice'
import { Route as OnboardingServicesRouteImport } from './routes/onboarding/services'
import { Route as OnboardingIdentityRouteImport } from './routes/onboarding/identity'
import { Route as OnboardingBankingRouteImport } from './routes/onboarding/banking'
import { Route as OnboardingLayoutRouteImport } from './routes/onboarding/_layout'
import { Route as KliciIdRouteImport } from './routes/klici/$id'

const StrankeRoute = StrankeRouteImport.update({
  id: '/stranke',
  path: '/stranke',
  getParentRoute: () => rootRouteImport,
} as any)
const PonudbeRoute = PonudbeRouteImport.update({
  id: '/ponudbe',
  path: '/ponudbe',
  getParentRoute: () => rootRouteImport,
} as any)
const KoledarRoute = KoledarRouteImport.update({
  id: '/koledar',
  path: '/koledar',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const NastavitveIndexRoute = NastavitveIndexRouteImport.update({
  id: '/nastavitve/',
  path: '/nastavitve/',
  getParentRoute: () => rootRouteImport,
} as any)
const KliciIndexRoute = KliciIndexRouteImport.update({
  id: '/klici/',
  path: '/klici/',
  getParentRoute: () => rootRouteImport,
} as any)
const PravnoSlugRoute = PravnoSlugRouteImport.update({
  id: '/pravno/$slug',
  path: '/pravno/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingVoiceRoute = OnboardingVoiceRouteImport.update({
  id: '/onboarding/voice',
  path: '/onboarding/voice',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingServicesRoute = OnboardingServicesRouteImport.update({
  id: '/onboarding/services',
  path: '/onboarding/services',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIdentityRoute = OnboardingIdentityRouteImport.update({
  id: '/onboarding/identity',
  path: '/onboarding/identity',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingBankingRoute = OnboardingBankingRouteImport.update({
  id: '/onboarding/banking',
  path: '/onboarding/banking',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingLayoutRoute = OnboardingLayoutRouteImport.update({
  id: '/onboarding/_layout',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const KliciIdRoute = KliciIdRouteImport.update({
  id: '/klici/$id',
  path: '/klici/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/koledar': typeof KoledarRoute
  '/ponudbe': typeof PonudbeRoute
  '/stranke': typeof StrankeRoute
  '/klici/$id': typeof KliciIdRoute
  '/onboarding': typeof OnboardingLayoutRoute
  '/onboarding/banking': typeof OnboardingBankingRoute
  '/onboarding/identity': typeof OnboardingIdentityRoute
  '/onboarding/services': typeof OnboardingServicesRoute
  '/onboarding/voice': typeof OnboardingVoiceRoute
  '/pravno/$slug': typeof PravnoSlugRoute
  '/klici/': typeof KliciIndexRoute
  '/nastavitve/': typeof NastavitveIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/koledar': typeof KoledarRoute
  '/ponudbe': typeof PonudbeRoute
  '/stranke': typeof StrankeRoute
  '/klici/$id': typeof KliciIdRoute
  '/onboarding': typeof OnboardingLayoutRoute
  '/onboarding/banking': typeof OnboardingBankingRoute
  '/onboarding/identity': typeof OnboardingIdentityRoute
  '/onboarding/services': typeof OnboardingServicesRoute
  '/onboarding/voice': typeof OnboardingVoiceRoute
  '/pravno/$slug': typeof PravnoSlugRoute
  '/klici': typeof KliciIndexRoute
  '/nastavitve': typeof NastavitveIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/koledar': typeof KoledarRoute
  '/ponudbe': typeof PonudbeRoute
  '/stranke': typeof StrankeRoute
  '/klici/$id': typeof KliciIdRoute
  '/onboarding/_layout': typeof OnboardingLayoutRoute
  '/onboarding/banking': typeof OnboardingBankingRoute
  '/onboarding/identity': typeof OnboardingIdentityRoute
  '/onboarding/services': typeof OnboardingServicesRoute
  '/onboarding/voice': typeof OnboardingVoiceRoute
  '/pravno/$slug': typeof PravnoSlugRoute
  '/klici/': typeof KliciIndexRoute
  '/nastavitve/': typeof NastavitveIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/koledar'
    | '/ponudbe'
    | '/stranke'
    | '/klici/$id'
    | '/onboarding'
    | '/onboarding/banking'
    | '/onboarding/identity'
    | '/onboarding/services'
    | '/onboarding/voice'
    | '/pravno/$slug'
    | '/klici/'
    | '/nastavitve/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/koledar'
    | '/ponudbe'
    | '/stranke'
    | '/klici/$id'
    | '/onboarding'
    | '/onboarding/banking'
    | '/onboarding/identity'
    | '/onboarding/services'
    | '/onboarding/voice'
    | '/pravno/$slug'
    | '/klici'
    | '/nastavitve'
  id:
    | '__root__'
    | '/'
    | '/koledar'
    | '/ponudbe'
    | '/stranke'
    | '/klici/$id'
    | '/onboarding/_layout'
    | '/onboarding/banking'
    | '/onboarding/identity'
    | '/onboarding/services'
    | '/onboarding/voice'
    | '/pravno/$slug'
    | '/klici/'
    | '/nastavitve/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  KoledarRoute: typeof KoledarRoute
  PonudbeRoute: typeof PonudbeRoute
  StrankeRoute: typeof StrankeRoute
  KliciIdRoute: typeof KliciIdRoute
  OnboardingLayoutRoute: typeof OnboardingLayoutRoute
  OnboardingBankingRoute: typeof OnboardingBankingRoute
  OnboardingIdentityRoute: typeof OnboardingIdentityRoute
  OnboardingServicesRoute: typeof OnboardingServicesRoute
  OnboardingVoiceRoute: typeof OnboardingVoiceRoute
  PravnoSlugRoute: typeof PravnoSlugRoute
  KliciIndexRoute: typeof KliciIndexRoute
  NastavitveIndexRoute: typeof NastavitveIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/stranke': {
      id: '/stranke'
      path: '/stranke'
      fullPath: '/stranke'
      preLoaderRoute: typeof StrankeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ponudbe': {
      id: '/ponudbe'
      path: '/ponudbe'
      fullPath: '/ponudbe'
      preLoaderRoute: typeof PonudbeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/koledar': {
      id: '/koledar'
      path: '/koledar'
      fullPath: '/koledar'
      preLoaderRoute: typeof KoledarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nastavitve/': {
      id: '/nastavitve/'
      path: '/nastavitve'
      fullPath: '/nastavitve/'
      preLoaderRoute: typeof NastavitveIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/klici/': {
      id: '/klici/'
      path: '/klici'
      fullPath: '/klici/'
      preLoaderRoute: typeof KliciIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pravno/$slug': {
      id: '/pravno/$slug'
      path: '/pravno/$slug'
      fullPath: '/pravno/$slug'
      preLoaderRoute: typeof PravnoSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/voice': {
      id: '/onboarding/voice'
      path: '/onboarding/voice'
      fullPath: '/onboarding/voice'
      preLoaderRoute: typeof OnboardingVoiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/services': {
      id: '/onboarding/services'
      path: '/onboarding/services'
      fullPath: '/onboarding/services'
      preLoaderRoute: typeof OnboardingServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/identity': {
      id: '/onboarding/identity'
      path: '/onboarding/identity'
      fullPath: '/onboarding/identity'
      preLoaderRoute: typeof OnboardingIdentityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/banking': {
      id: '/onboarding/banking'
      path: '/onboarding/banking'
      fullPath: '/onboarding/banking'
      preLoaderRoute: typeof OnboardingBankingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/_layout': {
      id: '/onboarding/_layout'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/klici/$id': {
      id: '/klici/$id'
      path: '/klici/$id'
      fullPath: '/klici/$id'
      preLoaderRoute: typeof KliciIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  KoledarRoute: KoledarRoute,
  PonudbeRoute: PonudbeRoute,
  StrankeRoute: StrankeRoute,
  KliciIdRoute: KliciIdRoute,
  OnboardingLayoutRoute: OnboardingLayoutRoute,
  OnboardingBankingRoute: OnboardingBankingRoute,
  OnboardingIdentityRoute: OnboardingIdentityRoute,
  OnboardingServicesRoute: OnboardingServicesRoute,
  OnboardingVoiceRoute: OnboardingVoiceRoute,
  PravnoSlugRoute: PravnoSlugRoute,
  KliciIndexRoute: KliciIndexRoute,
  NastavitveIndexRoute: NastavitveIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
